/* Import Section - Start */

/* React Imports - Start */

import React, { useEffect, useState } from "react";

/* React Imports - End */

/* Plugin Imports - Start */

import { Dropdown } from "primereact/dropdown";
import { useIsEdited } from "../../Providers/IsEditedProvider";

/* Plugin Imports - End */

/* Import Section - End */

/* Function - Start */

const SingleSelectElement = (props) => {
  /* State Declaration - Start */

  /* useState - Start */

  const [selectedValue, setSelectedValue] = useState(props.value);
  const { setIsEdited } = useIsEdited();

  /* useState - End */

  /* State Declaration - End */

  /* Methods - Start */

  useEffect(() => {
    setSelectedValue(props.value ? props.value : "");
  }, [props.value]);

  const onValueChange = (e) => {
    setIsEdited(true);
    setSelectedValue(e.value);
    if (e.value[props.optionLabel] === '-- Please select --'){
      props.onChangeValue(e.value);
    }
    else{
      props.onChangeValue(e);
    }
  };

  const valueTemplate = (option) => {
    return (
      <div
        style={{
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          maxWidth: '100%',
        }}
      >
        {option ? option[props.optionLabel] : '-- Please Select --'}
      </div>
    );
  };

  /* Methods - End */

  /* Render View Return - Start */

  return (
    <div className="flex align-center selecting-dropdown">
      <h5 className="dropdown-heading">{props.dropdownName}</h5>
      <Dropdown
        name={props.name}
        id={props.id}
        // value={selectedValue}
        value={props.value === null ? null : selectedValue}
        options={[{ [props.optionLabel]: '-- Please select --', value: null }, ...props.options]}
        onChange={(e) => onValueChange(e)}
        optionLabel={props.optionLabel}
        optionValue={props.optionValue}
        filter
        filterBy={props.filterBy}
        optionDisabled="true"
        placeholder={props.placeholder}
        className={props.className}
        disabled={props.disabled}
        defaultValue={props.defaultValue}
        tooltip={props.tooltip}
        showClear={props.showClear}
        title={props.value != undefined ? props.value[props.optionLabel] : ''}
        valueTemplate={valueTemplate}
      />
    </div>
  );

  /* Render View Return - End */
};

/* Function - End */

/* Export default functionName; */

export default SingleSelectElement;
